import { FC, ReactNode } from 'react'
import cn from 'classnames'
import { FeedUserBadges } from 'components/features/socialFeed/FeedUserInfo/FeedUserBadges'
import { FeedBadge } from 'interfaces/feed'
import { FeedUserBadgesProps } from 'components/features/socialFeed/FeedUserInfo/FeedUserBadges'
import styles from 'components/features/socialFeed/FeedUserInfoLayout/FeedUserInfoLayout.styl'

export type FeedUserInfoLayoutProps = {
  avatarChild: ReactNode
  userNameChild: ReactNode
  dateChild: ReactNode
  badges: FeedBadge[]
  mode: 'post' | 'comment'
  children?: ReactNode
  badgesProps?: Omit<FeedUserBadgesProps, 'badges' | 'mode' | 'className'>
  className?: string
}

export const FeedUserInfoLayout: FC<FeedUserInfoLayoutProps> = ({
  userNameChild,
  avatarChild,
  badges,
  mode,
  dateChild,
  badgesProps,
  className,
  children,
}) => {
  const badgeLastChildClassName = styles[`lastChild${ badges.length }` as keyof typeof styles]
  return (
    <div className={ cn(styles.feedUserInfo, { [styles.commentMode]: mode === 'comment' }, className) }>
      <div className={ styles.avatar }>
        { avatarChild }
      </div>
      <div className={ styles.info }>
        <div className={ styles.firstLine }>
          <div className={ styles.username }>
            { userNameChild }
          </div>
          <FeedUserBadges
            { ...badgesProps }
            badges={ badges }
            mode={ mode }
            className={ cn(styles.userBadge, badgeLastChildClassName) }
          />
          { Boolean(children) && (
            <div className={ styles.children }>
              { children }
            </div>
          ) }
        </div>
        <div className={ styles.date }>
          { dateChild }
        </div>
      </div>
    </div>
  )
}
